import angular from 'angular';

angular
  .module('cloudX')
  .controller('EmployeeAccessDialogCtrl', [
    'flySvc',
    '$http',
    'appUrls',
    'close',
    'relationId',
    employeeAccessDialogCtrl,
  ]);

function employeeAccessDialogCtrl(flySvc, $http, appUrls, close, relationId) {
  var vm = this;
  vm.lines = [];

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };

  $http.get(appUrls.api + '/Api/Relation/EmployeeAccess/' + relationId).then(
    function({ data = [] }) {
      vm.lines = data;
    },
    function(error) {
      vm.lines = [];
      showError(error);
    },
  );

  vm.cancel = function() {
    close(null, 500);
  };
}
